@let _benefitsDTO = benefitsDTO();
<nz-row [nzGutter]="[16, 16]">
  <nz-col [nzSpan]="24">
    <h2 class="benefits-title" nz-typography>{{ _benefitsDTO.title }}</h2>
  </nz-col>
  @for (
    benefitDTO of _benefitsDTO.benefits;
    track benefitDTO.title;
    let count = $count;
    let index = $index;
    let last = $last;
    let odd = $odd
  ) {
    <nz-col
      [nzLg]="{ span: getSpanValue('lg', count, index, last, odd), offset: 0 }"
      [nzMd]="{ span: getSpanValue('md', count, index, last, odd), offset: 0 }"
      [nzSm]="{ span: getSpanValue('sm', count, index, last, odd), offset: 0 }"
      [nzXl]="{ span: getSpanValue('xl', count, index, last, odd), offset: 0 }"
      [nzXs]="{
        span: getSpanValue('xs', count, index, last, odd),
        offset: 0,
      }">
      <nz-card [nzBordered]="false" [nzTitle]="optionTitle" class="height-100">
        <p nz-typography>{{ benefitDTO.value }}</p>
        <ng-template #optionTitle>
          <h3
            [ngClass]="['benefit-title', 'index', getIndexClass(index)]"
            nz-typography>
            {{ benefitDTO.title }}
          </h3>
        </ng-template>
      </nz-card>
    </nz-col>
  }
</nz-row>
